import React, { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var TabIndexContextValue = /*#__PURE__*/createContext(null);
function TabIndexContext(_ref) {
  var disabled = _ref.disabled,
    children = _ref.children;
  return /*#__PURE__*/_jsx(TabIndexContextValue.Provider, {
    value: disabled,
    children: children
  });
}
function useTabIndexContext() {
  var isTabIndexDisabled = useContext(TabIndexContextValue);
  if (isTabIndexDisabled === null) {
    return undefined;
  }
  return isTabIndexDisabled ? -1 : 0;
}
export { useTabIndexContext };
export default TabIndexContext;